const menu = () => {
    const linksScrollTo = document.querySelectorAll('.js-scrollto');

    const nav = document.querySelector('[data-main-menu="menu"]');
    const triggerNav = document.querySelectorAll('[data-main-menu="trigger"]');
    const body = document.querySelector('body');


    triggerNav.forEach(current => {
        current.addEventListener('click', () => {
            if (window.matchMedia('(max-width: 1081.1px)').matches) {
                nav.classList.toggle('is-open');
                current.classList.toggle('is-open');
                body.classList.toggle('is-main-menu-open');
            }
        });
    });

    linksScrollTo.forEach(current => {
        current.addEventListener('click', (e) => {
            const selector = current.getAttribute('href');
            if (selector.startsWith("#")) {
                e.preventDefault();
                body.classList.remove('is-main-menu-open');
                const element = document.querySelector(selector);
                element.scrollIntoView({ behavior : 'smooth' });
                nav.classList.remove('is-open');
                document.querySelector('[data-main-menu="trigger"]').classList.remove('is-open');
            }
        });
    });

};

export default menu;

